export default "__VITE_ASSET__CPIirn1S__"